import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function heatmapCell(theme: Theme): ComponentStyle {
  return {
    componentName: 'heatmapCell',
    baseStyle: {
      backgroundColor: theme.colors.foreground
    }
  };
}
